import { render } from "./SidebarNavigationLink.vue?vue&type=template&id=8012633a&ts=true"
import script from "./SidebarNavigationLink.vue?vue&type=script&lang=ts"
export * from "./SidebarNavigationLink.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__